import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '@env/environment';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.url.startsWith(environment.API_AUTH_BASE)) {
    return next(request);
  }

  const token = inject(OAuthService).getAccessToken();
  if (!token || request.headers.has('Authorization')) {
    return next(request);
  }

  return next(request.clone({
    setHeaders: { Authorization: `Bearer ${token}` },
  }));
};
